export default {
  connectToDataSource: 'Połącz ze źródłem danych',
  noDataSourceFound: 'Ten zasób nie jest podłączony do żadnego obsługiwanego systemu SCADA ani kontrolera',
};
